import React from "react";
import classNames from "classnames/bind";
import styles from "./Navigation.module.scss";
import NavigationDropdown from "./NavigationDropdown/NavigationDropdown";
import { Link } from "react-router-dom";

const cx = classNames.bind(styles);

const Navigation = ({
  menuItems,
  activeDropdown,
  onMouseEnter,
  onMouseLeave,

}) => {


  const handleRenderItem = (item, index) => {
    if (!item.dropdown) {

      return (<Link
        to={`/${item.key.toLowerCase().split("_").join("-")}`} //About_us->about-us
        key={item.name}
        className={cx("navigation__item")}
        onMouseEnter={() => onMouseEnter(index, item)}
        onMouseLeave={onMouseLeave}
      >
        <span
          className={cx("navigation__link", {
            "navigation__link--active": activeDropdown === index,
          })}
        >
          {item.name}
        </span>
      </Link>)
    } else {
      return (<div
        key={item.name}
        className={cx("navigation__item")}
        onMouseEnter={() => onMouseEnter(index, item)}
        onMouseLeave={onMouseLeave}
      >
        <span
          className={cx("navigation__link", {
            "navigation__link--active": activeDropdown === index,
          })}
        >
          {item.name}
        </span>

        {item.dropdown && activeDropdown === index && (
          <NavigationDropdown dropdown={item.dropdown} />
        )}
      </div>)
    }
  }

  return (
    <nav className={cx("navigation")}>
      {menuItems.map((item, index) => (
        handleRenderItem(item, index)
      ))}
    </nav>
  );
};

export default Navigation;
